import store from '../store';
import Vue from 'vue';

function requireSuperAdmin(next, redirectName = 'calibration_list') {
  const isSuperAdmin = store.state.superAdminData === 'false' ? false : store.state.superAdminData;
  if (!isSuperAdmin) next({ name: redirectName });
  else next();
}

const meta = { requiresAuth: true };

const Reviews = () => import(/* webpackChunkName: "reviews" */ '@/views/reviews/Root');
const ReviewsOverview = () => import(/* webpackChunkName: "reviews-overview" */ '@/views/reviews/overview/Index');
const ReviewsCycle = () => import(/* webpackChunkName: "reviews-cycle" */ '@/views/reviews/cycle/Index');
const ReviewsCycleList = () => import(/* webpackChunkName: "reviews-cycle-list" */ '@/views/reviews/cycle/List');
const ReviewsCycleCreate = () => import(/* webpackChunkName: "reviews-cycle-create" */ '@/views/reviews/cycle/create/Create');
const ReviewsCycleEdit = () => import(/* webpackChunkName: "reviews-cycle-edit" */ '@/views/reviews/cycle/create/Create');
const ReviewsCycleDetail = () => import(/* webpackChunkName: "reviews-cycle-detail" */ '@/views/reviews/cycle/Detail');
const ReviewsCycleDetailCycle = () => import(/* webpackChunkName: "reviews-cycle-detail-cycle" */ '@/views/reviews/cycle/DetailCycle');
const ReviewsCycleImportReviewerWeight = () =>
  import(/* webpackChunkName: "reviews-cycle-import-reviewer-weight" */ '@/views/reviews/cycle/import/ReviewerWeight');
const ReviewsPerformance = () => import(/* webpackChunkName: "reviews-performance" */ '@/views/reviews/performance-review/Root');
const ReviewsPerformanceTask = () =>
  import(/* webpackChunkName: "reviews-performance-task" */ '@/views/reviews/performance-review/pending-action/Index');

const ReviewsPerformancePendingActionActive = () =>
  import(/* webpackChunkName: "performance-review-pending-action-active" */ '@/views/reviews/performance-review/pending-action/active/List');
const ReviewsPerformancePendingActionArchive = () =>
  import(/* webpackChunkName: "performance-review-pending-action-active" */ '@/views/reviews/performance-review/pending-action/archive/List');
const ReviewsPerformancePendingActionActiveDetail = () =>
  import(/* webpackChunkName: "performance-review-pending-action-active-detail" */ '@/views/reviews/performance-review/pending-action/active/Detail');
const ReviewsPerformancePendingActionActiveImportCompetency = () =>
  import(
    /* webpackChunkName: "performance-review-pending-action-active-import-competency" */ '@/views/reviews/performance-review/pending-action/active/import/Competency'
  );
const ReviewsPerformancePendingActionArchiveDetail = () =>
  import(
    /* webpackChunkName: "performance-review-pending-action-archive-detail" */ '@/views/reviews/performance-review/pending-action/archive/Detail'
  );
const ReviewsPerformanceMyReview = () => import(/* webpackChunkName: "reviews-performance-index" */ '@/views/reviews/performance-review/MyReview');

const ReviewsCalibrationRoot = () => import(/* webpackChunkName: "reviews-calibration-root" */ '@/views/reviews/calibration/Root');
const ReviewsCalibrationIndex = () => import(/* webpackChunkName: "reviews-calibration-index" */ '@/views/reviews/calibration/Index');
const ReviewsCalibrationDetail = () => import(/* webpackChunkName: "reviews-calibration-detail" */ '@/views/reviews/calibration/Detail');
const ReviewsCalibrationForm = () => import(/* webpackChunkName: "reviews-calibration-form" */ '@/views/reviews/calibration/Form');
const ReviewsCalibrationMasterGroup = () =>
  import(/* webpackChunkName: "reviews-calibration-master-group" */ '@/views/reviews/calibration/master-group/Index');
const ReviewsCalibrationGroupList = () => import(/* webpackChunkName: "reviews-calibration-group-list" */ '@/views/reviews/calibration/GroupList');
const ReviewsCalibrationIntro = () => import(/* webpackChunkName: "reviews-calibration-intro" */ '@/views/reviews/calibration/Intro');
const ReviewsCalibrationUpload = () => import(/* webpackChunkName: "reviews-calibration-upload" */ '@/views/reviews/calibration/Upload');

export default [
  {
    path: '/reviews',
    component: Reviews,
    children: [
      {
        path: '',
        name: 'reviews',
        meta,
        redirect: 'performance-review',
      },
      {
        path: 'overview',
        name: 'review_overview',
        meta,
        component: ReviewsOverview,
      },
      {
        path: 'review-cycle',
        meta,
        component: ReviewsCycle,
        children: [
          {
            path: '',
            name: 'review_cycle_list',
            component: ReviewsCycleList,
          },
          {
            path: 'create',
            name: 'review_cycle_create',
            component: ReviewsCycleCreate,
          },
          {
            path: 'edit/:id',
            name: 'review_cycle_edit',
            component: ReviewsCycleEdit,
          },
          {
            path: ':id',
            name: 'review_cycle_detail',
            component: ReviewsCycleDetail,
          },
          {
            path: ':slug/detail-cycle/:id',
            name: 'review_cycle_detail_cycle',
            component: ReviewsCycleDetailCycle,
          },
          {
            path: ':slug/detail-cycle/:id/import/reviewer-weight',
            name: 'review_cycle_import_reviewer_weight',
            component: ReviewsCycleImportReviewerWeight,
          },
        ],
      },
      {
        path: 'performance-review',
        meta,
        component: ReviewsPerformance,
        children: [
          {
            path: 'pending-action',
            component: ReviewsPerformanceTask,
            children: [
              {
                path: 'active',
                name: 'performance-review_pending-action_active',
                component: ReviewsPerformancePendingActionActive,
              },
              {
                path: 'active/detail/:uuid',
                name: 'performance-review_pending-action_active_detail',
                component: ReviewsPerformancePendingActionActiveDetail,
              },
              {
                path: 'active/import/competency/:uuid',
                name: 'performance-review_pending-action_active_detail_import_competency',
                component: ReviewsPerformancePendingActionActiveImportCompetency,
              },
              {
                path: 'archive',
                name: 'performance-review_pending-action-archive',
                component: ReviewsPerformancePendingActionArchive,
              },
              {
                path: 'archive/detail/:uuid',
                name: 'performance-review_pending-action_archive_detail',
                component: ReviewsPerformancePendingActionArchiveDetail,
              },
              {
                path: '',
                name: 'performance_review_root',
                redirect: 'active',
              },
            ],
          },
          {
            path: 'my-review',
            name: 'performance_review_my_review',
            component: ReviewsPerformanceMyReview,
          },
          {
            path: '',
            name: 'performance_review',
            redirect: 'pending-action',
          },
          {
            path: 'tasks/detail/:uuid',
            redirect: to => ({
              name: 'performance-review_pending-action_active_detail',
              params: { uuid: to.params.uuid },
            }),
          },
          {
            path: '*',
            name: 'performance_review_pending-action_old',
            redirect: 'pending-action',
          },
        ],
      },
      {
        path: 'calibration',
        meta,
        component: ReviewsCalibrationRoot,
        beforeEnter: async (to, from, next) => {
          const isSuperAdmin = store.state.superAdminData === 'false' ? false : store.state.superAdminData;
          const isAccessCalibration = Vue.$cookies.get('can-access-calibration') === 'true';
          if (!isAccessCalibration && !isSuperAdmin) next({ name: 'home' });
          else next();
        },
        children: [
          {
            path: '',
            name: 'calibration_list',
            component: ReviewsCalibrationIndex,
            beforeEnter: async (to, from, next) => {
              const isAccessCalibration = Vue.$cookies.get('can-access-calibration') === 'true';
              if (!isAccessCalibration) next({ name: 'calibration_intro' });
              else next();
            },
          },
          {
            path: 'introduction',
            name: 'calibration_intro',
            component: ReviewsCalibrationIntro,
          },
          {
            path: 'group/:uuid',
            name: 'calibration_group_list',
            component: ReviewsCalibrationGroupList,
          },
          {
            path: 'form',
            name: 'calibration_create',
            component: ReviewsCalibrationForm,
            beforeEnter: (to, from, next) => requireSuperAdmin(next, 'calibration_list'),
          },
          {
            path: 'form/:id?',
            name: 'calibration_edit',
            component: ReviewsCalibrationForm,
            beforeEnter: (to, from, next) => requireSuperAdmin(next, 'calibration_list'),
          },
          {
            path: 'master-group',
            name: 'calibration_master_group_index',
            component: ReviewsCalibrationMasterGroup,
            beforeEnter: (to, from, next) => requireSuperAdmin(next, 'calibration_list'),
          },
          {
            path: 'upload/:id',
            name: 'calibration_upload',
            component: ReviewsCalibrationUpload,
          },
          {
            path: ':id',
            name: 'calibration_detail',
            component: ReviewsCalibrationDetail,
          },
        ],
      },
    ],
  },
];
